import { Injectable, inject } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { PagedCollectionQuery, PagedCollectionQueryResult, PagedCollectionQueryResultDTO } from '@skylab-shared/business';
import { HttpService, QueryHandler, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { InventoryEffect } from '@skylab-shared/dataModel';
import { Mutable } from '@skylab-shared/types';
import { Transform } from 'class-transformer';

export type InventoryStocktakingGridItem = InventoryStocktakingGridItemDTO;

class InventoryStocktakingGridItemDTO {
    public readonly id: number;
    public readonly version: string;
    @Transform(transformDTODate, { toClassOnly: true }) public readonly stocktakingDate: Date;
    public readonly inventoryEffect: InventoryEffect;
    public readonly documentNumber: string;
    public readonly relatedGoodsIssue?: {
        number: string;
        documentId: number;
    };
    public readonly relatedGoodsReceipt?: {
        number: string;
        documentId: number;
    };
}

export class InventoryStocktakingGridQuery extends PagedCollectionQuery<InventoryStocktakingGridItem> { }

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(InventoryStocktakingGridQuery)
export class InventoryStocktakingGridQueryHandler implements QueryHandler<InventoryStocktakingGridQuery, PagedCollectionQueryResult<InventoryStocktakingGridItem>> {
    #url = TaggedUrl.join('inventory/stocktaking', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(query: InventoryStocktakingGridQuery): Promise<PagedCollectionQueryResult<InventoryStocktakingGridItem>> {
        const { data } = await this.#http.get<Mutable<PagedCollectionQueryResult<InventoryStocktakingGridItem>>>(this.#url, {
            params: { ...query.params },
            dtoObject: new PagedCollectionQueryResultDTO<InventoryStocktakingGridItemDTO>(InventoryStocktakingGridItemDTO)
        });

        return {
            items: data.items,
            totalItemsCount: data.totalItemsCount
        };
    }
}
